import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moJob from './store';
import PDF from '../component/pdf';
import Title from '../component/title';
import HeadPdf from '../component/head-pdf';
import FootPdf from '../component/foot-pdf';
import moIndex from '../store/index';
import Table from './table';
import Desc from './desc';

interface IProps {
  list: any[];
}
interface IState {}

const TablePDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { list } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <PDF>
      <section className="hot-job_1515">
        <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
        <section className="content-1515">
          <section className="hot-job_1616"
            style={{ marginTop: '20px' }}>
            <Table list={list} />
          </section>
        </section>
        <FootPdf />
      </section>
    </PDF>
  );
};

export default observer(TablePDF);
